import { useRef, useState } from 'react'
import { IconButton, Tooltip } from '@mui/material'
import { VolumeUp, GraphicEq } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

interface WordAudioButtonProps {
  audioUrl?: string | null
  size?: 'small' | 'medium'
}

/**
 * Кнопка проигрывания озвучки слова (HTML5 Audio, как в CardViewPage).
 */
export function WordAudioButton({ audioUrl, size = 'small' }: WordAudioButtonProps) {
  const { t } = useTranslation()
  const [playing, setPlaying] = useState(false)
  const audioRef = useRef<HTMLAudioElement | null>(null)

  if (!audioUrl) {
    return null
  }

  const handlePlay = (event: React.MouseEvent) => {
    event.stopPropagation()
    if (playing) {
      audioRef.current?.pause()
      audioRef.current = null
      setPlaying(false)
      return
    }
    const audio = new Audio(audioUrl)
    audioRef.current = audio
    setPlaying(true)
    audio.onended = () => setPlaying(false)
    audio.onerror = () => setPlaying(false)
    void audio.play().catch(() => setPlaying(false))
  }

  return (
    <Tooltip title={t('tts.play', 'Прослушать')}>
      <IconButton size={size} onClick={handlePlay} color={playing ? 'primary' : 'default'}>
        {playing ? <GraphicEq fontSize={size} /> : <VolumeUp fontSize={size} />}
      </IconButton>
    </Tooltip>
  )
}
